import script from "./DesktopNumbersTableIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopNumbersTableIntegration.vue?vue&type=script&setup=true&lang=js"

import "./DesktopNumbersTableIntegration.vue?vue&type=style&index=0&id=2a9d38e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9d38e6"]])

export default __exports__